// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3mSWY","content":"LoadingAlert_content__23Kxl"};